import { NgModule } from "@angular/core";
import { ActionComponent } from "src/app/components/ui/actions/action.component";
import { ActionSeparatorComponent } from "src/app/components/ui/actions/action-separator.component";
import { TagComponent } from "src/app/components/ui/actions/tag.component";
import { ActionGroupComponent } from "src/app/components/ui/actions/action-group.component";

@NgModule({
  imports: [],
  declarations: [
    ActionComponent,
    ActionGroupComponent,
    ActionSeparatorComponent,
    TagComponent
  ],
  exports: [
    ActionComponent,
    ActionGroupComponent,
    ActionSeparatorComponent,
    TagComponent
  ]
})
export class ActionsModule {}
